import { BASE_URL } from 'config';
import React, { useState, useEffect } from "react";
import {
  Box,
  TextField,
  Select,
  MenuItem,
  Button,
  Typography,
  FormControl,
  FormHelperText,
  Grid,
  InputLabel,
  Autocomplete, // أضف هذا السطر
} from "@mui/material";
import { validateEmail, validateRequired, validatePasswordMatch } from "validations";
import axios from "axios";
import Swal from "sweetalert2";
import { useMaterialUIController } from "context";
import { useTheme } from "@mui/material/styles";
const AddLocationsForm = ({ onClose, onSuccess, initialData }) => {
  const [controller] = useMaterialUIController();
  const darkMode = controller.darkMode;
  const theme = useTheme();
  const [locations, setLocations] = useState([]);
  const [location_types, setLocation_types] = useState([]);
  useEffect(() => {
    const fetchLocations = async () => {
      const token = localStorage.getItem("user-token");
      try {
        const response = await fetch(
          BASE_URL + "/administrator/locations",
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const data = await response.json();
        setLocations(data.data);
      } catch (error) {
        console.error("Error fetching Stores:", error);
      }
    };
    fetchLocations();
  }, []);
  useEffect(() => {
    const fetchLocationTypes = async () => {
      const token = localStorage.getItem("user-token");
      try {
        const response = await fetch(
          BASE_URL + "/administrator/location-types",
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const data = await response.json();
        setLocation_types(data.data);
      } catch (error) {
        console.error("Error fetching Stores:", error);
      }
    };
    fetchLocationTypes();
  }, []);
  const [formData, setFormData] = useState({
    name: initialData?.name || "",
    parent_id: initialData?.parent_id || null,
    type_id: initialData?.type_id || null,
    code: initialData?.code || "",
    is_active: initialData?.is_active || 1,
    id: initialData?.id || null, // Add ID field
  });

  // Add useEffect to handle initial data
  useEffect(() => {
    if (initialData) {
      setFormData({
        name: initialData.name,
        parent_id: initialData.parent_id,
        type_id: initialData.type_id,
        code: initialData.code,
        is_active: initialData.is_active,
        id: initialData.id,
      });
    }
  }, [initialData]);
  const [errors, setErrors] = useState({});
  const [formSubmitted, setFormSubmitted] = useState(false);

  useEffect(() => {
    if (formSubmitted) validateForm();
  }, [formData]);

  const validateForm = () => {
    const newErrors = {};

    if (!validateRequired(formData.name)) newErrors.name = "يجب إدخال الاسم";
    if (!formData.type_id) newErrors.type_id = "يجب إدخال تصنيف الموقع";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormSubmitted(true);

    if (!validateForm()) return;

    try {
      const formPayload = new FormData();
      // Append all form data including files
      Object.entries(formData).forEach(([key, value]) => {
        if (value !== null && value !== undefined && key !== "id") {
          formPayload.append(key, value);
        }
      });

      // Show loading indicator
      Swal.fire({
        title: "جاري الحفظ...",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
          const container = document.querySelector(".swal2-container");
          container.style.zIndex = "99999";
        },
      });
      console.log("the location is active: ", formData.is_active);
      console.log("Sending payload:", formPayload); // طباعة البيانات المرسلة
      const token = localStorage.getItem("user-token");
      const endpoint = formData.id
        ? `${BASE_URL}/administrator/locations/update/${formData.id}`
        : BASE_URL + "/administrator/locations/store";
      const response = await axios.post(endpoint, formPayload, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      });
      // طباعة تفاصيل الرد
      console.log("Full Response:", response);
      console.log("Response Data:", response.data);
      console.log("Status Code:", response.status);
      // Close loading indicator
      Swal.close();

      if (response.data.status) {
        await Swal.fire({
          icon: "success",
          title: "تم الحفظ!",
          text: "تم حفظ البيانات بنجاح",
          confirmButtonText: "موافق",
          didOpen: () => {
            const container = document.querySelector(".swal2-container");
            container.style.zIndex = "99999";
          },
        });
        onSuccess();
        onClose();
      } else {
        throw new Error(response.data.message || "حدث خطأ غير متوقع");
      }
    } catch (error) {
      Swal.close();
      console.error("Error Details:", error);
      console.log("Error Response:", error.response?.data);
      const errorMessage = error.response?.data?.message || error.message || "حدث خطأ أثناء  الحفظ";

      Swal.fire({
        icon: "error",
        title: "فشل الحفظ!",
        text: errorMessage,
        confirmButtonText: "موافق",
        didOpen: () => {
          const container = document.querySelector(".swal2-container");
          container.style.zIndex = "99999";
        },
      });
    } finally {
      setFormSubmitted(false);
    }
  };

  const handleCancel = () => {
    setFormData({
      name: "",
      type_id: null,
      code: "",
      parent_id: null,
      is_active: 1,
    });
    setErrors({});
    onClose();
  };
  const handleRemoveImage = () => {
    setFormData((prev) => ({ ...prev, avatar: null }));
  };
  return (
    <Box
      sx={{
        p: 3,
        width: 600,
        bgcolor: darkMode ? theme.palette.background.default : "background.paper",
        borderRadius: 2,
        boxShadow: 3,
        color: darkMode ? "white !important" : "inherit",
      }}
    >
      {/* Header */}
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
        <Typography variant="h5" fontWeight="bold">
          {formData.id ? "تعديل الموقع" : "إضافة موقع جديد"}
        </Typography>
      </Box>
      <Typography variant="subtitle1" gutterBottom fontWeight="bold">
        معلومات الموقع
      </Typography>
      {/* Main Form */}
      <Box display="flex" justifyContent="center" alignItems="center" gap={2}>
        <FormControl fullWidth error={!!errors.name} sx={{ mb: 2 }}>
          <TextField
            label="اسم دولة - حي - مدينة - منطقة "
            name="name"
            value={formData.name}
            onChange={handleChange}
            error={!!errors.name}
            helperText={errors.name}
          />
        </FormControl>
        <FormControl fullWidth sx={{ mb: 2 }}>
          <InputLabel id="location_activing">حالة الموقع </InputLabel>
          <Select
            labelId="location_activing"
            name="is_active"
            value={formData.is_active}
            onChange={handleChange}
            sx={{ height: 43 }}
          >
            <MenuItem value="1">نشط</MenuItem>
            <MenuItem value="0">غير نشط</MenuItem>
          </Select>
        </FormControl>
      </Box>
      <Box display="flex" justifyContent="center" alignItems="center" gap={2}>
        <FormControl fullWidth error={!!errors.code} sx={{ mb: 2 }}>
          <TextField
            label="كود المنطقة "
            name="code"
            value={formData.code}
            onChange={handleChange}
            error={!!errors.code}
            helperText={errors.code || "كود المنطقة مثلا اذا دولة"}
          />
        </FormControl>
        <FormControl fullWidth sx={{ mb: 2 }}>
          <InputLabel id="parent_id_location" shrink>
          </InputLabel>
          <Autocomplete
            options={locations}
            getOptionLabel={(option) => option.name || ""}
            value={locations.find((loc) => loc.id === formData.parent_id) || ""}
            onChange={(event, newValue) => {
              setFormData((prev) => ({ ...prev, parent_id: newValue ? newValue.id : null }));
            }}
            renderOption={(props, option) => (
              <li {...props} key={option.id + "-" + (option.name || "")}>
                {option.name}
              </li>
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                label="تابع ل..."
                error={!!errors.parent_id}
                helperText="تابع ل... اسم الموقع التابع له دولة - مدينة"
              />
            )}
            isOptionEqualToValue={(option, value) => option.id === value.id}
          />
          <FormHelperText error>{errors.parent_id}</FormHelperText>
        </FormControl>
        <FormControl fullWidth sx={{ mb: 2 }}>
          <InputLabel id="location_type" shrink>
            نوع التصنيف
          </InputLabel>
          <Autocomplete
            options={location_types}
            getOptionLabel={(option) => option.name || ""}
            value={location_types.find((type) => type.id === formData.type_id) || ""}
            onChange={(event, newValue) => {
              setFormData((prev) => ({ ...prev, type_id: newValue ? newValue.id : null }));
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="نوع التصنيف"
                error={!!errors.type_id}
                helperText="نوع التصنيف هل دولة - مدينة - قارة"
                sx={{ color: "text.border" }}
              />
            )}
            isOptionEqualToValue={(option, value) => option.id === value.id}
          />
          <FormHelperText error>{errors.type_id}</FormHelperText>
        </FormControl>
      </Box>

      {/* Actions Section */}
      <Box mt={4} display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="body2" color="text.border">
          * الحقول المطلوبة
        </Typography>

        <Box display="flex" gap={2}>
          <Button variant="outlined" color="error" onClick={handleCancel} sx={{ px: 4, borderColor: "text.border" }}>
            إلغاء
          </Button>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            // disabled={Object.keys(errors).length > 0}
            sx={{ px: 4, color: "white !important", bgcolor: "primary.dark", "&:hover": { bgcolor: "primary.main" } }}
            onClick={handleSubmit}
          >
            حفظ
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default AddLocationsForm;
